// Session-Identität für Pages/Stores, die user-scoped WS-Kanäle
// abonnieren wollen (z.B. "push:web:<uid>", "auth:<uid>"). App.svelte
// setzt die ID einmal nach dem Auth-Status-Fetch — Pages müssen dafür
// nicht selbst /v2-api/auth/status ziehen. Reaktiv ($state), damit ein
// $effect mit sessionUserID() nachfeuert, sobald die ID da ist.

let _userID = $state<number | undefined>(undefined);

export function setSessionUserID(id: number | undefined): void {
  _userID = id;
}

/** User-ID der laufenden Session; undefined bis der Auth-Check durch ist. */
export function sessionUserID(): number | undefined {
  return _userID;
}
